import "react-loading-skeleton/dist/skeleton.css";
import "./index.css";

import * as React from "react";
import * as ReactDOM from "react-dom/client";
import { TgglClient, TgglProvider } from "react-tggl-client";

import * as amplitude from "@amplitude/analytics-browser";
import * as Sentry from "@sentry/react";

import { setupChatbotApiInterceptors } from "@virtual-brain-lib/frontend-api";
import { sentryDefaultConfiguration, TGGL_CLIENT_API_KEY } from "@virtual-brain-lib/frontend-utils";

import App from "./App";
import env from "./environments";
import reportWebVitals from "./reportWebVitals";
import { authenticate } from "./utils/auth";

/**
 * CHATBOT API AXIOS CONFIG
 */
setupChatbotApiInterceptors({
	getChatbotId: () => window.location.pathname.split("/")?.[1],
	isPreview: Boolean(new URLSearchParams(window.location.search).get("preview")),
	onAuthError: authenticate,
});

/**
 * TGGL CONFIG
 */

const tgglClient = new TgglClient(TGGL_CLIENT_API_KEY);

/**
 * SENTRY CONFIG
 */

Sentry.init({
	enabled: env.appEnv !== "development",
	environment: env.appEnv,
	dsn: env.sentryDsn,
	...sentryDefaultConfiguration,
});

const root = ReactDOM.createRoot(document.getElementById("root")!);

root.render(
	<React.StrictMode>
		<TgglProvider client={tgglClient}>
			<App />
		</TgglProvider>
	</React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
amplitude.init("a13fd1e83199bf7d3222566ae2a10ace", undefined, {
	defaultTracking: {
		sessions: true,
		pageViews: true,
		formInteractions: true,
		fileDownloads: true,
	},
});
